export default __webpack_public_path__ + "static/media/lieferheld_grid_s.746b0c80.jpg";